import { useScreen, useGrid } from "vue-screen";
import tailwindScreens from "#twcss/theme/screens";

export const screen = useScreen();
export const grid = useGrid({
  base: "0px",
  ...tailwindScreens,
});
